<div class="centered-with-padding py-7">
  <div [class.mx-auto]="data.isCentered" class="flex items-center gap-5 desk:w-[900px] desk:gap-8">
    <div [style.rotate]="stickerOrientation()" class="w-36 shrink-0">
      <app-svg [src]="data.sticker.svg.svg" />
    </div>
    <div class="flex flex-col">
      <app-title [title]="{ text: data.title, as: 'span' }" size="h2"></app-title>
      @if (data.cta; as cta) {
        <div class="mt-3 hidden desk:block">
          <app-button [label]="cta.label" [url]="cta.url" />
        </div>
      }
    </div>
  </div>
  @if (data.cta; as cta) {
    <div class="mx-auto mt-7 block w-fit desk:hidden">
      <app-button [label]="cta.label" [url]="cta.url" />
    </div>
  }
</div>
